import { proofPoints } from '../content'
import { Icon } from './Icon'

export function ProofBand() {
  return (
    <section className="proof" aria-label="Ark Solutions service proof points">
      <div className="container proof-grid">
        {proofPoints.map((point) => (
          <article className="proof-item" key={point.label}>
            <span className="icon-ring" aria-hidden="true">
              <Icon name={point.icon} />
            </span>
            <strong>{point.label}</strong>
          </article>
        ))}
      </div>
    </section>
  )
}
